import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { K } from "../theme";
import { Cd } from "./Card";

export const Stat = ({ icon: Ic, label, value, sub, trend, up, c = K.p }) =>
  <Cd>
    <div className="flex justify-between items-start mb-[10px]">
      <div className="w-9 h-9 rounded-[10px] flex items-center justify-center border" style={{ background: `${c}10`, borderColor: `${c}18` }}>
        <Ic size={17} color={c} />
      </div>
      {trend && <span className={`flex items-center gap-[2px] text-[14px] font-semibold ${up ? "text-g" : "text-r"}`}>{up ? <ArrowUpRight size={11} /> : <ArrowDownRight size={11} />}{trend}</span>}
    </div>
    <div className="text-[22px] font-extrabold text-t0 tracking-[-0.02em] leading-none">{value}</div>
    <div className="text-[14px] text-t2 mt-[3px]">{label}</div>
    {sub && <div className="text-[12px] text-t3 mt-[1px]">{sub}</div>}
  </Cd>;
